__turbopack_context__.v({
  "blocksBackgroundColor": "StaffBlock-module-scss-module__0nZaVG__blocksBackgroundColor",
  "blocksFontColor": "StaffBlock-module-scss-module__0nZaVG__blocksFontColor",
  "childSlideContainer": "StaffBlock-module-scss-module__0nZaVG__childSlideContainer",
  "cleverSliderContainer": "StaffBlock-module-scss-module__0nZaVG__cleverSliderContainer",
  "container": "StaffBlock-module-scss-module__0nZaVG__container",
  "instructionsCard": "StaffBlock-module-scss-module__0nZaVG__instructionsCard",
  "loading": "StaffBlock-module-scss-module__0nZaVG__loading",
  "noStaff": "StaffBlock-module-scss-module__0nZaVG__noStaff",
  "reorderContainer": "StaffBlock-module-scss-module__0nZaVG__reorderContainer",
  "reorderInstructions": "StaffBlock-module-scss-module__0nZaVG__reorderInstructions",
  "scrollArrowClassName": "StaffBlock-module-scss-module__0nZaVG__scrollArrowClassName",
  "searchContainer": "StaffBlock-module-scss-module__0nZaVG__searchContainer",
  "searchbar": "StaffBlock-module-scss-module__0nZaVG__searchbar",
  "secondaryNavBackgroundColor": "StaffBlock-module-scss-module__0nZaVG__secondaryNavBackgroundColor",
  "slideItem": "StaffBlock-module-scss-module__0nZaVG__slideItem",
  "sliderClassName": "StaffBlock-module-scss-module__0nZaVG__sliderClassName",
  "staffListSection": "StaffBlock-module-scss-module__0nZaVG__staffListSection",
  "themeBackgroundColor": "StaffBlock-module-scss-module__0nZaVG__themeBackgroundColor",
  "themeFontColor": "StaffBlock-module-scss-module__0nZaVG__themeFontColor",
  "themeFontFamily": "StaffBlock-module-scss-module__0nZaVG__themeFontFamily",
  "trackClassContainer": "StaffBlock-module-scss-module__0nZaVG__trackClassContainer",
  "viewMore": "StaffBlock-module-scss-module__0nZaVG__viewMore",
  "viewMoreButton": "StaffBlock-module-scss-module__0nZaVG__viewMoreButton",
});
